import { DateTime } from 'luxon'

export const formatDateShort = (date: string) => {
  return date && DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT)
}

export const formatDateMed = (date: string) => {
  return date && DateTime.fromISO(date).toLocaleString(DateTime.DATE_MED)
}

export const formatDateFull = (date: string) => {
  return date && DateTime.fromISO(date).toLocaleString(DateTime.DATE_FULL)
}

export const formatDateTimeShort = (date: string) => {
  return date && DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT)
}

export const formatDateTimeMed = (date: string) => {
  return date && DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED)
}

export const formatDateTimeFull = (date: string) => {
  return date && DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_FULL)
}

export const formatTimeSimple = (time: string) => {
  return time && DateTime.fromISO(time).toLocaleString(DateTime.TIME_SIMPLE)
}

export const formatDateOnlyMed = (date: string) => {
  return date && DateTime.fromISO(date).toFormat('LLL d, yyyy')
}

export const formatMeetingDuration = (
  startDate: string,
  startTime?: string | null,
  endDate?: string | null,
  endTime?: string | null
): string => {
  if (startTime && endTime) {
    const start = DateTime.fromISO(startTime)
    const end = DateTime.fromISO(endTime)

    if (start.toISODate() !== end.toISODate()) {
      return `${start.toFormat('LLL dd, yyyy HH:mm')} - ${end.toFormat('LLL dd, yyyy HH:mm')}`
    }

    return `${start.toFormat('LLL dd, yyyy • HH:mm')} - ${end.toFormat('HH:mm')}`
  }

  const withYear = 'LLL dd, yyyy'
  if (startDate && endDate) {
    const start = DateTime.fromISO(startDate)
    const end = DateTime.fromISO(endDate)

    if (start.year !== end.year) {
      return `${start.toFormat(withYear)} - ${end.toFormat(withYear)}`
    }

    return `${start.toFormat('LLL dd')} - ${end.toFormat(withYear)}`
  }

  return DateTime.fromISO(startDate).toFormat(withYear)
}

export const getTimestampNow = (): string => {
  return DateTime.now().toLocaleString(DateTime.DATETIME_MED)
}
